import { CSS as CheckBoxCSS } from '../../components/input/input.checkbox';
import { Spinner } from '../../components/spinner/spinner';
import { DefaultTheme } from '../../components/theme';
import { CSS as TagCardCheckBoxCSS } from '../tag.card.checkbox/tag.card.checkbox.style';

export const CIRCLE_RADIUS = DefaultTheme.spacingFactor * 4;
export const CIRCLE_SIZE_PX = CIRCLE_RADIUS * 2 + 'px';

export const CSS = {
	container: 'c-TagCard',
	containerLeft: 'c-TagCard__left',
	toolbar: 'c-TagCard__toolbar',
	renamejob: 'c-TagCard__renamejob',
	isHovered: 'c-TagCard--is-hovered',
};

export const Style = {
	[CSS.container]: {
		height: DefaultTheme.space(10),
		'line-height': DefaultTheme.space(6),
		display: 'flex',
		padding: DefaultTheme.space(1),

		'align-items': 'center',
		'justify-content': 'center',
		'&:hover': {
			backgroundColor: DefaultTheme.font.color.divider,
		},
		[`& .${CSS.toolbar}`]: {
			display: 'none',
		},
		[`&:hover .${CSS.toolbar}`]: {
			display: 'flex',
		},
	},
	[CSS.isHovered]: {
		backgroundColor: DefaultTheme.font.color.divider,
	},
	[CSS.containerLeft]: {
		display: 'flex',
		alignItems: 'center',
		width: CIRCLE_SIZE_PX,
		height: CIRCLE_SIZE_PX,
	},
	[CSS.toolbar]: {
		display: 'flex',
		position: 'relative',
	},
	[CSS.renamejob]: {
		width: DefaultTheme.space(8),
		height: DefaultTheme.space(8),
	},
	[`${CSS.container} .${TagCardCheckBoxCSS.container}`]: {
		width: CIRCLE_SIZE_PX,
		height: CIRCLE_SIZE_PX,
	},
	[`${CSS.container} .${CheckBoxCSS.container}`]: {
		marginLeft: DefaultTheme.spacingFactor,
	},
	[`${CSS.container} .${Spinner.CSS.container}`]: {
		marginTop: DefaultTheme.space(1),
	},
};
